import graphql from 'graphql-tag'
import client from '@stores/apollo'
import { IAssetTag } from '@api/types'
import { AssetTagFragment } from '@api/fragments'

export default function details(id: string): Promise<IAssetTag> {
  return client.gql
    .query({ query: assetQuery, variables: { id } })
    .then(({ data: { node } }: { data: { node: IAssetTag } }) => node)
}

const assetQuery = graphql`
  query assetDetails($id: ID!) {
    node(id: $id) {
      ...AssetTagFragment
    }
  }
  ${AssetTagFragment}
`
